class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    const inputWhitelist = [
      '.facet',
      '.collection-actions-wrapper',
    ]

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.debouncedOnSubmitReduced = debounce((event) => {
      this.onSubmitHandler(event);
    }, 250, true);

    this.addEventListener('input', (event) => {
      if (!inputWhitelist.some(selector => !!event.target.closest(selector))) {
        return false;
      }

      if (event.target.closest('price-range')) {
        this.debouncedOnSubmit(event);
      } else {
        this.debouncedOnSubmitReduced(event);
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) {
        return;
      }

      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, appendResults) {
    if (!searchParams && window.location.href.includes('filter.v.m')) {
      let params = new URLSearchParams(window.location.href);
      let idx = '';
      let ID = '';
      let fullSpec = '';
      let model = '';
      params = Array.from(params);
      for (i = 0; i < params.length; i++) {
        if (params[i][0] == 'model') {
          model = `model=${params[i][1]}`
        }
        if (params[i][0] == 'idx') {
          idx = `&idx=${params[i][1]}`
        }
        if (params[i][0] == 'ID') {
          ID = `&ID=${params[i][1]}`
        }
        if (params[i][0] == 'filter.v.m.tyre_spec.size_full') {
          fullSpec = `${fullSpec}&filter.v.m.tyre_spec.size_full=${params[i][1]}`
        }
        if (params[i][0] == 'filter.v.m.wsp.sf') {
          fullSpec = `${fullSpec}&filter.v.m.wsp.sf=${params[i][1]}`
        }
      }
      searchParams = `${model}${idx}${ID}${fullSpec}`
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event, appendResults);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }

    if (!searchParams.includes('page')) {
      publish(PUB_SUB_EVENTS.collectionFilters, {
        filters: deserializeSearchParams(searchParams),
      });
    }
  }

  static renderSectionFromFetch(url, event, appendResults) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        let html = responseText;
        if (window.location.href.includes('vehicle-lookup') || window.location.href.includes('wheel-lookup')) {
          let filterList = [];
          let paramURL = `?${url.split('?')[1]}`;
          let pars = new URLSearchParams(paramURL);
          let keySet = Array.from(new Set(pars.keys()));
          for (i = 0; i < keySet.length; i++) {
            let keyObj = { key: keySet[i], values: [] }
            filterList.push(keyObj)
          }
          let parSet = Array.from(pars)
          let parString = '';
          let inputString = ''
          for (i = 0; i < parSet.length; i++) {
            if (parSet[i][0] != 'model') {
              if (parSet[i][0] == 'idx') {
                localStorage.setItem('idx', parSet[i][1]);
              }
              if (parSet[i][0] == 'ID') {
                localStorage.setItem('vID', parSet[i][1]);
                //inputString = `${inputString}<input type="hidden" name="ID" value="${parSet[i][1]}" class="facet-filter-checkbox" checked form="FacetsFilterForm">`
              }
              if (parSet[i][0].includes('filter.v.m.tyre_spec.size_full')) {
                parString = `${parString}&${parSet[i][0]}=${parSet[i][1]}`;
                inputString = `${inputString}<input type="hidden" name="filter.v.m.tyre_spec.size_full" value="${parSet[i][1]}" class="facet-filter-checkbox" checked form="FacetsFilterForm">`
              }
              if (parSet[i][0].includes('filter.v.m.wsp.sf')) {
                parString = `${parString}&${parSet[i][0]}=${parSet[i][1]}`;
                inputString = `${inputString}<input type="hidden" name="filter.v.m.wsp.sf" value="${parSet[i][1]}" class="facet-filter-checkbox" checked form="FacetsFilterForm">`
              }
            }
          }
          parString = `${parString.replace('&', '?filter_params')}endparams`;
          for (i = 0; i < filterList.length; i++) {
            for (q = 0; q < parSet.length; q++) {
              if (filterList[i].key == parSet[q][0]) {
                if (parSet[q][1] == '0') {
                  filterList[i].values.push('false');
                } else if (parSet[q][1] == '1') {
                  filterList[i].values.push('true');
                } else {
                  filterList[i].values.push(parSet[q][1]);
                }
              }
            }
          }
          let pDOM = new DOMParser().parseFromString(html, 'text/html')
          pDOM.getElementById('formTarget').outerHTML = inputString;
          let prodCards = pDOM.querySelectorAll('product-card');
          for (i = 0; i < prodCards.length; i++) {
            let varData = JSON.parse(prodCards[i].getElementsByClassName('fullSizing')[0].textContent);
            let chosenVariant
            for (q = 0; q < varData.length; q++) {
              if (chosenVariant) {
                break;
              }
              let specCheck = [];
              for (let g = 0; g < varData[q].vMeta.length; g++) {
                for (let z = 0; z < filterList.length; z++) {
                  if (filterList[z].key == varData[q].vMeta[g].filterName) {
                    specCheck.push(1);
                    if (!filterList[z].values.includes(varData[q].vMeta[g].value)) {
                      specCheck.push(0);
                    }
                  }
                }
              }
              if (specCheck.includes(1) && !specCheck.includes(0)) {
                chosenVariant = varData[q];
                break;
              }
            }
            if (chosenVariant) {
              let address = prodCards[i].querySelector('a').href.substring(0, prodCards[i].querySelector('a').href.indexOf('?'));
              let pushPrice = `$${chosenVariant.vPrice.substring(0, (chosenVariant.vPrice.length - 2))}.${chosenVariant.vPrice.substring((chosenVariant.vPrice.length - 2), chosenVariant.vPrice.length)}`;
              let addressHREF = `${address}?variant=${chosenVariant.vID}?${parString}`
              addressHREF = addressHREF.replaceAll(' ', '+');
              pDOM.querySelectorAll('product-card')[i].querySelectorAll('a')[0].href = addressHREF;
              pDOM.querySelectorAll('product-card')[i].querySelectorAll('a')[2].href = addressHREF;
              pDOM.querySelectorAll('product-card')[i].getElementsByClassName('price-item')[0].innerHTML = pushPrice;
              if (prodCards[i].innerHTML.includes('secondary_text">Buy 3') && prodCards[i].getElementsByClassName('primary_promotion').length > 0) {
                let buy3Price = chosenVariant.vPrice - 2500;
                buy3Price = buy3Price.toString();
                let buy3PushPrice = `SAVE $${buy3Price.substring(0, (buy3Price.length - 2))}`;
                pDOM.querySelectorAll('product-card')[i].getElementsByClassName('primary_promotion')[0].querySelector('h3').innerHTML = buy3PushPrice;
              } else if (prodCards[i].innerHTML.includes('% Off</span>') && prodCards[i].getElementsByClassName('primary_promotion').length > 0) {
                let pcPrice = prodCards[i].innerHTML.split('% Off</span>')[0].substring((prodCards[i].innerHTML.split('% Off')[0].length - 2), prodCards[i].innerHTML.split('% Off')[0].length);
                pcPrice = Number(pcPrice);
                let pcPushPrice = Math.floor((chosenVariant.vPrice * 4) * (pcPrice / 100));
                pcPushPrice = pcPushPrice.toString();
                pDOM.querySelectorAll('product-card')[i].getElementsByClassName('primary_promotion')[0].querySelector('h3').innerHTML = `SAVE $${pcPushPrice.substring(0, (pcPushPrice.length - 2))}`
              } else if (prodCards[i].innerHTML.toLowerCase().includes('cash back') && prodCards[i].getElementsByClassName('primary_promotion').length > 0) {
                let pcPrice = prodCards[i].getElementsByClassName('ribbon')[0].innerHTML.toLowerCase().split(' cash')[0].substring((prodCards[i].getElementsByClassName('ribbon')[0].innerHTML.toLowerCase().split(' cash')[0].indexOf('$') + 1), prodCards[i].getElementsByClassName('ribbon')[0].innerHTML.toLowerCase().split(' cash')[0].length);
                pcPrice = Number(pcPrice);
                let pcPushPrice = pcPrice;
                pcPushPrice = pcPushPrice.toString();
                prodCards[i].getElementsByClassName('primary_promotion')[0].querySelector('h3').innerHTML = `SAVE $${pcPushPrice}`;
              }
              html = pDOM.body.innerHTML;
            }
          }
        }
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderCollectionActions(html);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, appendResults);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderCollectionActions(html);
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html, appendResults) {
    const container = document.getElementById('ProductGridContainer');
    const parsedDom = new DOMParser().parseFromString(html, 'text/html');

    if (appendResults) {
      parsedDom.getElementById('product-grid')
        .prepend(...[...document.getElementById('product-grid').childNodes]);
    }
    if (window.location.pathname.includes('wheel-lookup') || window.location.pathname.includes('vehicle-lookup')) {
      if (localStorage.getItem('currentRear') == 'true') {
        searchFits(localStorage.getItem('currentidx'), 1);
      } else {
        searchFits(localStorage.getItem('currentidx'), 0);
      }
    }
    container.innerHTML = parsedDom.getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML
    const container = document.getElementById('ProductCount');

    if (!container) {
      return;
    }

    container.innerHTML = count;
    container.classList.remove('loading');
  }

  static renderCollectionActions(html) {
    const container = document.getElementById('CollectionActions');
    const parsedDom = new DOMParser().parseFromString(html, 'text/html');

    if (!container || !parsedDom.getElementById('CollectionActions')) {
      return;
    }

    container.classList = parsedDom.getElementById('CollectionActions').classList;
  };

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const oldFacetElements =
      document.querySelectorAll('#FacetFiltersForm .js-filter');

    const newFacetElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');

    const isPriceFilter = (element) => {
      return !!element.querySelector('price-range');
    };

    const expandedFacets = [];
    document.querySelectorAll('.js-filter collapsible-expandable[expanded="true"]')?.forEach(node => {
      const parent = node.closest('.js-filter');
      if (node.getAttribute('expanded')) {
        expandedFacets.push(parent.dataset.name);
      }
    });

    const facetsContainer = document.querySelector('#FacetFiltersForm .page-layout-sidebar-inner-content');

    let priceInserted = false;
    const oldPriceFacet = Array.from(oldFacetElements).find(facet => isPriceFilter(facet));

    document.querySelectorAll('#FacetFiltersForm .js-filter')?.forEach(facet => !isPriceFilter(facet) && facet.remove());

    newFacetElements.forEach(element => {
      const isExpanded = expandedFacets.includes(element.dataset.name);
      element.querySelector('.facet-toggle').setAttribute('aria-expanded', isExpanded);
      element.querySelector('collapsible-expandable').setAttribute('expanded', isExpanded);

      if (!oldPriceFacet) {
        facetsContainer.append(element);
      } else {
        if (!isPriceFilter(element) && !priceInserted) {
          oldPriceFacet.before(element);
        } else if (!isPriceFilter(element) && priceInserted) {
          facetsContainer.append(element);
        } else if (isPriceFilter(element)) {
          oldPriceFacet.querySelector('.js-price-range-header').innerHTML = element.querySelector('.js-price-range-header').innerHTML;
          priceInserted = true;
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
  }


  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.collection-actions-filters'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) {
        return;
      }

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static updateURLHash(searchParams, replace) {
    if (replace) {
      history.replaceState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    } else {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(document.getElementById('FacetsFilterForm'));
    const searchParams = new URLSearchParams(formData).toString();
    //carveout to handle non-standard params when vehicle selector is in use
    if (searchParams.includes('filter.v.m.tyre_spec.size_full') || searchParams.includes('filter.v.m.wsp.sf')) {
      //fix for when filter is deselected after fitment has change
      if (event.target.outerHTML.includes('checked')) {
        let windowParams = new URLSearchParams(window.location.search).toString();
        let decodedParams = decodeURIComponent(windowParams);
        decodedParams = decodedParams.replaceAll(`${event.target.name}=${event.target.value.replaceAll(' ', '+')}`, '').replaceAll('&&', '&').replaceAll('?&', '?').replaceAll('%+', '%25+');
        FacetFiltersForm.renderPage(decodedParams, event);
      } else {
        let decodedParams = decodeURIComponent(searchParams).replaceAll(' ', '+').replaceAll('&&', '&').replaceAll('?&', '?').replaceAll('%+', '%25+');
        FacetFiltersForm.renderPage(decodedParams, event);
      }
    } else {
      FacetFiltersForm.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onAjaxPagination(event) {
    event.preventDefault();
    const next = event.currentTarget;
    const url = next.href.indexOf('?') == -1 ? '' : next.href.slice(next.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, event, true);
    scrollToElement(document.getElementById('ProductGridContainer'), -150);

    const params = new URLSearchParams(url);
    publish(PUB_SUB_EVENTS.pageChange, {
      page: Number(params.get('page')),
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class AjaxPaginate extends HTMLElement {
  constructor() {
    super();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    const buttons = this.querySelectorAll('a');

    buttons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        form.onAjaxPagination(event);
      });
    });
  }
}

customElements.define('ajax-paginate', AjaxPaginate);

function scrollToElement(element, offset) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  window.scrollTo({
    top: absoluteElementTop + offset,
    behavior: 'smooth'
  });
}

/**
 * Accepts a query string from faceted filtering and returns a
 * deserialized object.
 *
 * @param {string} queryString The query string.
 * @returns {{}}
 */
const deserializeSearchParams = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};

  for (const [key, value] of params.entries()) {
    if (result[key]) {
      result[key] = `${result[key]},${value}`
    } else if (value) {
      result[key] = value;
    }
  }

  return result
}
